<template lang="pug">

.vs
	Loading(v-show="initialFail")
	transition(name='fade')
		.ge-head_team-wrap(v-show="isVersusReady")
			.ge-head_team.ge-head_team--local
				img.ge-head_team__img(:src="$store.state.match.localImage", :alt="$store.state.match.localShortName")
				span.ge-head_team__name {{ $store.state.match.localNameSafeLength }}
			NavQuarter(v-if="!isPreMatch")
			.ge-head_team.ge-head_team--visitor
				img.ge-head_team__img(:src="$store.state.match.visitorImage", :alt="$store.state.match.visitorShortName")
				span.ge-head_team__name {{ $store.state.match.visitorNameSafeLength }}
	Loading(v-if="userRequestFail")
	transition(name='fade')
		.vs-gra-wrap(v-if="!userRequestFail && isOverview && isVersusReady")
			.vs-gra-subwrap
				VersusStat(
					v-for="(value, name) in globals.local_team"
					v-if="isOverview ? isOvStat(name) : true"
					:key="name"
					:localStat="globals.local_team[name]"
					:visitingStat="globals.visiting_team[name]"
				)
	transition(name='fade')
		.vs-gra-wrap(v-if="!userRequestFail && isGlobals && isVersusReady")
			.vs-gra-subwrap
				VersusStat(
					v-for="(value, name) in globals.local_team"
					v-if="isWrap1StatGlobals(name)"
					:key="name"
					:localStat="globals.local_team[name]"
					:visitingStat="globals.visiting_team[name]"
				)
			.vs-gra-subwrap
				VersusStat(
					v-for="(value, name) in globals.local_team"
					v-if="isWrap2StatGlobals(name)"
					:key="name"
					:localStat="globals.local_team[name]"
					:visitingStat="globals.visiting_team[name]"
				)
			.vs-gra-subwrap
				VersusStat(
					v-for="(value, name) in globals.local_team"
					v-if="isWrap3StatGlobals(name)"
					:key="name"
					:localStat="globals.local_team[name]"
					:visitingStat="globals.visiting_team[name]"
				)
	transition(name='fade')
		.vs-gra-wrap(v-if="!userRequestFail && isPreMatch && isVersusReady")
			.vs-gra-subwrap
				VersusStat(
					v-for="(value, name) in globals.local_team"
					v-if="isWrap1StatPreMatch(name)"
					:key="name"
					:localStat="globals.local_team[name]"
					:visitingStat="globals.visiting_team[name]"
				)
			.vs-gra-subwrap
				VersusStat(
					v-for="(value, name) in globals.local_team"
					v-if="isWrap2StatPreMatch(name)"
					:key="name"
					:localStat="globals.local_team[name]"
					:visitingStat="globals.visiting_team[name]"
				)
			.vs-gra-subwrap
				VersusStat(
					v-for="(value, name) in globals.local_team"
					v-if="isWrap3StatPreMatch(name)"
					:name="name"
					:key="name"
					:localStat="globals.local_team[name]"
					:visitingStat="globals.visiting_team[name]"
				)
			

</template>

<style lang="sass">

.vs
	max-width: 600px
	width: 100%
	margin: 0 auto
	box-sizing: border-box
	display: grid
	grid-gap: 3rem

	&-head
		display: flex
		flex-direction: row
		justify-content: space-between
		align-items: flex-end
		&__shield
			max-height: 50px
	&-gra
		$visitor: #bdbdbd
		&-wrap
			display: grid
			grid-auto-flow: row
			grid-gap: 2rem
			
		&-subwrap
			display: grid
			grid-auto-flow: row
			grid-gap: 2.3rem
			padding-bottom: 2rem

		&-info
			display: grid
			grid-template-columns: 1fr auto 1fr
			flex-direction: row
			justify-items: start
			padding-bottom: 0.8em
			align-items: center

			&__leg
				font-weight: $bold
				font-size: 1.1em

			&__lab
				padding: 0.25em 0.8em
					bottom: 0.25em
				&:not(:first-child)
					justify-self: end
					&.vs-gra-info__lab--winner
						background-color: $visitor
						color: $black
						
				&--winner
					color: $white
					background-color: $local
					border-radius: 10px
					font-weight: $bold
		&-sco
			position: relative
			display: flex
			flex-direction: row
			justify-content: space-between
			background-color: $white
			height: 8px
			&__local
				background-color: $local
				height: 100%
				flex-shrink: 1
				flex-basis: 0%
				transition: flex-grow 1s

			&__visitor
				background-color: $visitor
				height: 100%
				flex-shrink: 1
				flex-basis: 0%
				transition: flex-grow 1s

			&__line
				position: absolute
				margin-left: auto
				margin-right: auto
				left: 0
				right: 0
				width: 2px
				top: -3px
				height: 14px
				background-color: $primary-color

</style>

<script>

import api from "@/api/index"

import VersusStat from "@/components/subcomponents/versus/VersusStat.vue"
import NavQuarter from "@/components/subcomponents/nav/NavQuarter.vue"
import Loading from "@/components/subcomponents/general/Loading.vue"


export default {
	name: "Globals",
	data() {
		return {
			filtered_globals: [],
			globals: { local_team: [], visiting_team: [] },
			userRequestFail: false,
			timer: null,
			initialFail: false,
			initialTimer: null
		}
	},
	computed: {
		refreshSignal() {
			return this.$store.state.general.refreshSignal
		},
		period() {
			return this.$store.state.match.selQuarter
		},
		isOverview() {
			return this.$route.name.split('.')[1] == 'overview'
		},
		isGlobals() {
			return this.$route.name.split('.')[1] == 'globals'
		},
		isPreMatch() {
			return this.$route.name.split('.')[1] == 'prematch'
		},
		actual() {
			return this.$store.state.general.actual
		},
		isVersusReady() {
			return this.$store.state.general.isVersusReady
		},
	},
	methods: {
		isOvStat(stat) {
			return [
				't1',
				't2',
				't3',
				'total_rebound',
			].includes(stat)
		},
		isWrap1StatGlobals(stat) {
			return [
				't1',
				't2',
				't3',
				'field',
			].includes(stat)
		},
		isWrap2StatGlobals(stat) {
			return [
				'total_rebound',
				'personal_fouls',
				'turnovers',
				'timeouts',
				'best_streak',
				'time_as_leader',
				'leader_changes',
				'maximun_difference',

			].includes(stat)
		},
		isWrap3StatGlobals(stat) {
			return [
				'points_after_steal',
				'points_in_the_paint',
				'second_opportunity_points',
				'counter_attack',
				'bench_points'
			].includes(stat)
		},
		isWrap1StatPreMatch(stat) {
			return [
				'points',
				'received_points',
			].includes(stat)
		},
		isWrap2StatPreMatch(stat) {
			return [
				't1',
				't2',
				't3',
				'field',
			].includes(stat)
		},
		isWrap3StatPreMatch(stat) {
			return [
				'defensive_rebound',
				'offensive_rebound',
				'asis',
				'steals',
				'turnovers',
				'blocks',
				'dunks',
				'val',
			].includes(stat)
		},
		updateGlobals() {
			if (this.isPreMatch) {
				let params = {
					idCompetition: this.actual.competition.id,
					idEdition: this.actual.edition.id,
					idClub1: this.$store.state.match.localIdClub,
					idClub2: this.$store.state.match.visitingIdClub,
					dateTo: this.$store.state.match.start_date
				}
				api.match.getPreMatchVersusStats(params)
					.then((data) => {
						this.$data.globals = data
						this.clearInitialTimer()
						this.clearTimer()
						if (data.local_team && data.visiting_team) {
							this.$store.commit("general/setVersusReady", true)
						} else {
							this.$store.commit("general/setVersusReady", false)

						}

					}
					)
			} else {
				api.match.getMatchVersusStats(this.$route.params.id_match, this.period)
					.then((data) => {
						this.$data.globals = data
						this.clearInitialTimer()
						this.clearTimer()
						this.$store.commit("general/setVersusReady", true)
					}
					)
			}
		},
		setTimer() {
			this.timer = setTimeout(
				() => {
					this.$data.userRequestFail = true
				},
				this.$store.state.general.requestTimeout
			)
		},
		clearTimer() {
			if (this.timer) {
				this.$data.userRequestFail = false
				this.$data.initialFail = false
				clearTimeout(this.timer)
			}
		},
		setInitialTimer() {
			this.timer = setTimeout(
				() => {
					this.$data.initialFail = true
				},
				this.$store.state.general.requestTimeout
			)
		},
		clearInitialTimer() {
			if (this.initialTimer) {
				this.$data.initialFail = false
				clearTimeout(this.initialTimer)
			}
		},
	},
	watch: {
		actual: {
			handler: function () {
				if (this.globals)
					this.updateGlobals()
			},
			deep: true
		},
		period() {
			this.setTimer()
			this.updateGlobals()
		},
		refreshSignal(newValue) {
			if (newValue) {
				if (this.$store.state.match.status == "playing" || this.$store.state.general.refreshing)
					this.updateGlobals()
			}
		}
	},
	created() {
		this.$store.commit("general/setVersusReady", false)
		if (this.actual.competition && this.actual.edition)
			this.setInitialTimer()
		this.updateGlobals()
	},
	components: {
		VersusStat,
		NavQuarter,
		Loading
	}
}

</script>